'use strict';

angular.module('atex.dam').controller('DamEngagementViewController', ['$scope', '$state', '$stateParams', '$rootScope', '$timeout',
function($scope, $state, $stateParams, $rootScope, $timeout) {
  
  var currentLineHeightThumbList = 120;
  $scope.selected  = [];
  $scope.toggle='col-lg-7';

  $scope.entries = $stateParams.items; 
  
  if (!$scope.entries) {
    $state.go('list');
  }
  
  $scope.back = function() {
    if ($rootScope.entryToaddInlistAfterDuplication){
      // Notify the list to focus on new duplicated element
      $timeout(function() {
        $rootScope.$broadcast('dam:selectNewDuplicatedItem');
      },1000);
    }
    $state.go('list');
  };
  
  $scope.clearSelection = function() {
    $scope.selected.length = 0;
  };
}]);

